import { ProviderConfig, ProviderTypes } from 'types';
import { StarlinkTheme } from 'config/themes';

export const Starlink: ProviderConfig = {
  providerType: ProviderTypes.WISP,
  providerCode: 'starlink',
  dcCode: 'Starlink',
  name: 'Starlink',
  displayName: 'Starlink',
  reskinTheme: StarlinkTheme,
  reskinTitle: 'Starlink Internet',
  showPricingDisclaimer: false,
  broadbandDisplayType: 'updater_generated',
  disclaimerDisplaySettings: {
    showContractDisclaimer: false,
    showOfferDisclaimer: true,
    showPromotionsDisclaimer: false,
  },
};
